<template>
  <div style="position: absolute; width: 100%; height: 100%; background: #f5f5f5">
    <headers></headers>

    <div style="display: flex; justify-content: center; background: #f5f5f5">
      <div class="consm">
        <left></left>
        <div class="banner">
        <div class="title">我的在学班级</div>

        <div class="styList">
          <div class="listBox" v-for="item in classList" :key="item.tClass.id">
            <div class="leftBox">
              <div>
                <img
                  class="imgBox"
                  v-if="item.tClass.classImage !== '' && item.tClass.classImage !== null"
                  :src="item.tClass.classImage"
                  alt=""
                  @error="handleError"
                />

                <div v-else class="imgBox" style="position: relative; display: flex; justify-content: center; align-items: center">
                  <img style="position: absolute; top: 0; left: 0; width: 100%; height: 100%" src="../../../assets/img/noimg.png" alt="" />
                  <div
                    style="
                      position: relative;
                      z-index: 11;
                      font-size: 15px;
                      font-family: kaiti;
                      text-align: center;
                      padding: 0 10px;
                      font-weight: bold;
                      color: #355fd9;
                      width: 100%;
                      height: 51px;
                      display: -webkit-box;
                      -webkit-line-clamp: 3;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                    "
                  >
                    {{ item.tClass.className }}

                  </div>
                </div>
              </div>

              <div class="left_2">
                <div class="text_1" :title="item.tClass.className">
                  {{ item.tClass.className }}
                </div>
                <div class="text_2">类型：{{ item.tClass.lx }}</div>
                <div class="text_3">报名学时：{{ item.tClass.orderCredit }}学时</div>
                <div class="text_4">
                  完成学时：{{
                    item.tClass.hasCredit >= item.tClass.orderCredit ? item.tClass.orderCredit : item.tClass.hasCredit
                  }}学时
                </div>
              </div>
            </div>

            <div class="centerBox">
              <div style="display: flex; justify-content: center" v-if="item.tClass.orderCredit !== 0">
                <div class="jindu" v-if="item.tClass.orderCredit > item.tClass.hasCredit">
                  已完成{{ Math.round((item.tClass.hasCredit / item.tClass.orderCredit) * 100) }}%
                </div>
                <div class="jindu" v-if="item.tClass.orderCredit <= item.tClass.hasCredit">已完成100%</div>
              </div>
              <el-progress
                v-if="item.tClass.orderCredit !== 0"
                :percentage="(item.tClass.hasCredit / item.tClass.orderCredit) * 100"
                color="#2878FF"
                :show-text="false"
              ></el-progress>
              <div class="vis1" v-if="item.tClass.isExam !== '01'">需要完成课程学习才能考试</div>
            </div>

            <div class="rightBox">
              <div @click="viewCourse(item)">查看课程</div>
              <div v-if="item.isGxk !== '02'" @click="goXX(item)" style="margin-top: 5px">学时证明</div>
            </div>
          </div>
        </div>
        </div>

        <!-- <right></right> -->
      </div>
    </div>
    <div class="pagination" style="display: flex; justify-content: center; background: #f5f5f5">
      <pagination
        background
        v-show="total > 0"
        :total="total"
        :page.sync="params.pageNum"
        :limit.sync="params.pageSize"
        @pagination="getList"
      >
      </pagination>
    </div>

    <div class="phoneBanner">
      <div style="text-align: center; font-size: 16px">{{ tips }}</div>
      <div class="phoneList" v-for="item in classList" :key="item.tClass.id">
        <div class="rightbox">{{ item.tClass.lx }}</div>
        <div class="phoneTitle">{{ item.tClass.className }}</div>

        <div class="cberBox">
          <div class="imgBox">
            <img
              v-if="item.tClass.classImage !== '' && item.tClass.classImage !== null"
              :src="item.tClass.classImage"
              alt=""
              @error="handleError"
            />

            <div v-else class="imgBox" style="position: relative; display: flex; justify-content: center; align-items: center">
              <img style="position: absolute; top: 0; left: 0; width: 100%; height: 100%" src="../../../assets/img/noimg.png" alt="" />
              <div
                style="
                  width: 100%;
                  position: relative;
                  z-index: 11;
                  font-size: 15px;
                  font-family: kaiti;
                  text-align: center;
                  padding: 0 10px;
                  font-weight: bold;
                  color: #355fd9;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 3; /* 限制行数为3 */
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ item.tClass.className }}
              </div>
            </div>
          </div>
          <div class="textBox" v-if="item.tClass.orderCredit !== 0">
            <div class="xuexi" v-if="item.tClass.orderCredit > item.tClass.hasCredit">
              总学习进度：{{ Math.round((item.tClass.hasCredit / item.tClass.orderCredit) * 100) }}%
            </div>
            <div class="xuexi" v-else>总学习进度：100%</div>
            <div class="textBox1">报名学时：{{ item.tClass.orderCredit }}学时</div>
            <div class="textBox2">完成学时：{{ item.tClass.hasCredit }}学时</div>
          </div>
        </div>

        <div class="xian"></div>

        <div class="btnBox">
          <div></div>
          <div style="display: flex">
            <!-- <div class="exam">参与考试</div> -->
            <div class="ke" @click="viewCourse(item)">查看课程</div>
          </div>
        </div>
      </div>

      <div style="text-align: center" class="more" @click="more">
        {{ text }}
      </div>
    </div>

    <!-- <flotRight></flotRight> -->
    <bottom></bottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import headers from '@/views/component/head.vue';
import bottom from '@/views/component/bottom.vue';
import left from '@/views/component/left.vue';
// import right from '@/views/component/right.vue';
// import flotRight from '@/views/component/flotRight.vue';
import { mapMutations } from 'vuex';
import { toMyClassList, doLogin, getUser, getUrl } from '../../../api/questions';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    headers,
    bottom,
    left,
    // right,
    // flotRight
  },
  data() {
    // 这里存放数据
    return {
      classList: [], //在学班级
      params: {
        pageNum: 1,
        pageSize: 5
      },
      total: 0,
      userInfo: {},
      text: '', //提示语
      tips: '', //无数据
      mobileCenterUrl: '',
      defaultImageUrl: require('../../../assets/images/noimg.png'),
      pcCenterUrl: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    ...mapMutations('m_user', ['updateToken']),
    goXX(item) {
     const route =this.$router.resolve({
        path: '/xszm',
        query: {
          classId: item.tClass.id
        }
      });
      window.open(route.href, '_blank');
    },
    handleError(event) {
      event.target.src = this.defaultImageUrl;
    },
    goStudy() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        window.location.replace(this.mobileCenterUrl + '?token=' + localStorage.getItem('token'));
      } else {
        window.location.replace(this.pcCenterUrl + '?token=' + localStorage.getItem('token'));
      }
    },
    // getUrl() {
    //   getUrl().then(res => {
    //     console.log(res.data.data);
    //     this.mobileCenterUrl = res.data.data.mobileCenterUrl;
    //     this.pcCenterUrl = res.data.data.pcCenterUrl;
    //     const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    //     if (isMobile) {
    //       localStorage.setItem('url', this.mobileCenterUrl);
    //     } else {
    //       localStorage.setItem('url', this.pcCenterUrl);
    //     }
    //   });
    // },
    more() {
      this.params.pageNum = this.params.pageNum + 1;
      toMyClassList(this.params).then(res => {
        if (res.data.code == '200') {
          this.classList.push(...res.data.rows);
          this.total = res.data.total;
          if (this.total <= this.params.pageSize * this.params.pageNum) {
            this.text = '';
          } else {
            this.text = '点击加载更多...';
          }
        } else {
          this.$message('请求错误,请稍后再试！');
        }
      });
    },

    back() {
      this.$router.back();
    },
    // getUser() {
    //   getUser().then(res => {
    //     console.log(res);
    //     this.userInfo = res.data.data;
    //   });
    // },
    //登录
    login() {
      doLogin(this.userInfo).then(res => {
        ////console.log(res);
        if (res.data.token) {
          this.updateToken(res.data.token);
          //拿到密钥存在本地存储
          localStorage.setItem('token', res.data.token);
          this.getList();
          this.getUser();
        } else {
          //登录失败
          this.$message({
            message: '服务异常！'
          });
        }
      });
    },
    //获取在学班级
    getList() {
      toMyClassList(this.params).then(res => {
        if (res.data.code == '200') {
          this.classList = res.data.rows;
          if (this.classList.length == 0) {
            this.tips = '暂无数据。。。';
          }
          this.total = res.data.total;
          if (this.total <= this.params.pageSize * this.params.pageNum) {
            this.text = '';
          } else {
            this.text = '点击加载更多...';
          }
        } else {
          this.$message('请求错误,请稍后再试！');
        }
      });
    },

    viewCourse(item) {
      if (item.isGxk == '02') {
        if (item.isAllowStudy == '01' && item.isAllowStudyGxk == '01') {
          this.$message('公需课平台维护，暂时不能学习！');
        } else if (item.isAllowStudyGxk == '01') {
          this.$message('此公需课程已结束，不允许学习和考试！');
          return false;
        } else if (item.isAllowStudy == '01') {
          this.$message('公需课平台维护，暂时不能学习！');
        }
      }

      this.$router.push({ path: '/questions', query: { name: item.tClass.className, id: item.tClass.id, orderId: item.orderId } });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(this.$route.query);
    if (this.$route.query.token) {
      // 拿到密钥存在本地存储
      this.updateToken(this.$route.query.token);
      //拿到密钥存在本地存储
      localStorage.setItem('token', this.$route.query.token);
      if (this.$route.query.classId) {
        let item = {
          orderId: this.$route.query.orderId,
          tClass: {
            className: this.$route.query.className,
            id: this.$route.query.classId,
            orderId: this.$route.query.orderId
          }
        };
        this.viewCourse(item);
        return false;
      }
      this.$router.replace({ path: '/', query: {} }); //存储好token之后清空携带的参数，防止出现多个浏览器共同学习bug
    }

    this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener(
      'storage',
      () => {
        this.$confirm('禁止打开多标签页！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showClose: false,
          distinguishCancelAndClose: true,
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(() => {
            window.open('about:blank', '_self');
            window.close();
          })
          .catch(() => {});
      },
      false
    );
    localStorage.setItem('Sentinel', Math.random());
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
@media (max-width: 768px) {
  .goStudy {
    position: absolute;
    z-index: 99;
    color: #fff;
    right: 15px;
    top: 7px;
    width: 100px;
    height: 32px;
    cursor: pointer;
    font-size: 13px;
    background: #438ce7;
    text-align: center;
    line-height: 32px;
    border-radius: 32px;
  }
  .head {
    display: none;
  }
  .more {
    font-size: 16px;
  }
  .phoneHead {
    width: 100%;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    font-family: Medium;
    .back {
      width: 50px;
      img {
        width: 25px;
        height: 25px;
      }
    }
    .texs {
      font-size: 17px;
    }
  }
  .banner {
    display: none;
  }
  .pagination {
    display: none !important;
  }
  .phoneBanner {
    background: #f5f5f9;
    padding: 10px 16px;
    font-family: Medium;
    .phoneList {
      position: relative;
      width: 100%;
      background: #ffffff;
      border-radius: 6px;
      padding: 21px 16px 16px 16px;
      margin-bottom: 15px;
      .rightbox {
        position: absolute;
        top: 0;
        right: 0;
        width: 83px;
        height: 29px;
        background: rgba(40, 120, 255, 0.15);
        font-size: 12px;
        color: #2878ff;
        text-align: center;
        line-height: 29px;
        border-radius: 0px 6px 0px 27px;
      }
      .phoneTitle {
        width: 255px;
        font-size: 19px;
        font-weight: 500;
        color: #333333;
        font-family: bold;
      }
      .cberBox {
        margin-top: 9px;
        display: flex;
        .imgBox {
          width: 120px;
          height: 96px;
          img {
            width: 120px;
            height: 96px;
          }
        }
        .textBox {
          font-family: Regular;
          margin-left: 12px;
          padding-top: 7px;
          .xuexi {
            background: rgba(255, 128, 0, 0.1);
            border-radius: 3px;
            color: #ff8000;
            font-size: 14px;
            text-align: center;
            padding: 5px 12px;
          }
          .textBox1 {
            margin-top: 8px;
            font-size: 15px;
            color: #8793a4;
          }
          .textBox2 {
            margin-top: 8px;
            font-size: 15px;
            color: #8793a4;
          }
        }
      }

      .xian {
        margin-top: 16px;
        width: 100%;
        height: 1px;
        background: #eeeeee;
      }
      .btnBox {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        .exam {
          width: 96px;
          height: 37px;
          border: 1px solid #8793a4;
          opacity: 1;
          text-align: center;
          line-height: 37px;
          border-radius: 6px;
          color: #8793a4;
          font-size: 15px;
        }
        .ke {
          width: 96px;
          height: 37px;
          border: 1px solid #2878ff;
          opacity: 1;
          text-align: center;
          line-height: 37px;
          border-radius: 6px;
          color: #2878ff;
          font-size: 15px;
          margin-left: 16px;
        }
      }
    }
  }
}
@media (min-width: 768px) {
  .phoneHead {
    display: none;
  }
  .consm {
    margin-top: 20px;
    width: 1400px;
    display: flex;
  }
  .goStudy {
    position: absolute;
    top: 110px;
    z-index: 99;
    color: #2674fa;
    cursor: pointer;
    font-family: Bold;
    text-align: center;
    line-height: 40px;
    font-size: 15px;
    width: 120px;
    height: 40px;
    background: #ffffff;
    border-radius: 20px;
    opacity: 0.7;
  }
  .head {
    width: 100%;
    height: 165px;
    line-height: 54px;
    display: flex;
    justify-content: center;
    background: #fff;
    .head_contet {
      width: 1200px;
      .text {
        font-size: 18px;
        font-weight: 600;
        height: 165px;
        line-height: 165px;
        color: #fff;
        text-align: center;
        position: relative;
        .userBox {
          position: absolute;
          right: 0;
          top: 110px;
          display: flex;
          width: 120px;
          height: 40px;
          border-radius: 20px;
          border: 1px solid #ffffff;
          .imgBox {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            opacity: 1;
            overflow: hidden;
            img {
              width: 30px;
              height: 30px;
            }
          }

          .nameBox {
            opacity: 0.7;
            font-size: 14px;
            line-height: 42px;
            margin-left: 8px;
          }
        }
      }
    }
  }
  .phoneBanner {
    display: none;
  }
  .pagination {
    padding: 20px 0 100px 0;
  }
  .banner {
    padding-top: 28px;
    width: 1170px;
    background: #fff;
    min-height: 780px;
    position: relative;
    z-index: 1;
    .title {
      font-size: 18px;
      color: #333333;
      font-family: Bold;
      padding-left: 20px;
    }

    .styList {
      margin-top: 13px;
      .listBox {
        margin-bottom: 12px;
        width: 1000px;
        height: 170px;
        background: #ffffff;
        padding: 20px 40px 20px 20px;
        display: flex;
        .leftBox {
          display: flex;
          .imgBox {
            width: 160px;
            height: 129px;
          }
          .left_2 {
            margin-left: 12px;
            .text_1 {
              cursor: pointer;
              margin-top: 8px;
              font-family: Bold;
              font-size: 18px;
              color: #333333;
              width: 355px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .text_2 {
              margin-top: 8px;
              height: 26px;
              text-align: left;
              font-family: Medium;
              line-height: 26px;
              color: #2878ff;
              border-radius: 2px;
              font-size: 12px;
            }
            .text_3 {
              margin-top: 12px;
              font-size: 14px;
              font-family: Medium;
              font-weight: 500;
              color: #666666;
            }
            .text_4 {
              margin-top: 5px;
              font-size: 14px;
              font-family: Medium;
              font-weight: 500;
              color: #666666;
            }
          }
        }

        .centerBox {
          width: 150px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 10px;
          .vis1 {
            margin-top: 8px;
            font-family: Medium;
            color: #666666;
            text-align: center;
            font-size: 14px;
          }
          .jindu {
            width: 92px;
            height: 24px;
            background: #2878ff;
            opacity: 1;
            border-radius: 4px;
            font-size: 12px;
            color: #ffffff;
            line-height: 24px;
            text-align: center;
          }
          .el-progress {
            width: 150px;
            height: 8px;
            margin-top: 12px;
          }
        }

        .rightBox {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 160px;
          div {
            width: 110px;
            height: 38px;
            background: #ffffff;
            border: 1px solid #2878ff;
            opacity: 1;
            border-radius: 4px;
            cursor: pointer;
            color: #2878ff;
            font-size: 14px;
            text-align: center;
            line-height: 38px;
            font-family: Regular;
          }
        }
      }
    }
  }
}
</style>
